/**
 * Chi può vedere il Radar Mercati.
 *
 * Il Radar nasce dal questionario che si compila **iscrivendosi da soli**: è
 * quello a dire che cosa vende l'azienda e a chi, ed è da quelle risposte che
 * il Radar calcola i Paesi. Chi non l'ha mai compilato — i clienti storici, gli
 * account creati da un amministratore, chiunque sia arrivato prima che il
 * questionario esistesse — un Radar non ce l'ha e non può averlo: la voce di
 * menu lo porterebbe su una pagina vuota, e la pagina vuota si legge come un
 * guasto.
 *
 * Il segno è la **risposta al questionario**, non la licenza di prova. Sembrano
 * la stessa cosa e non lo sono: chi ha fatto la prova e poi ha comprato un
 * piano non ha più una licenza `TRIAL`, ma il giro l'ha fatto e il suo Radar
 * esiste. Legarlo alla licenza vorrebbe dire togliergli una pagina sua il
 * giorno in cui paga.
 *
 * Il profilo porta più di quanto l'SDK dichiari: le risposte del questionario
 * sono state aggiunte al servizio dopo la generazione del client, e si leggono
 * con un restringimento — come già fanno la procedura guidata e la ricerca
 * aziende — invece di aspettare un giro di pubblicazione.
 */
export type UtenteConRadar = {
  readonly productNameRadar?: string;
  readonly productDescriptionRadar?: string;
  readonly buyerRoleRadar?: string;
};

/**
 * Se questa persona ha compilato il questionario del Radar.
 *
 * Basta **una** delle risposte: il questionario si compila per intero, ma un
 * profilo a cui ne manca una per una modifica successiva ha comunque fatto il
 * giro, e chiudergli il Radar per un campo svuotato sarebbe peggio che
 * lasciarglielo aperto.
 */
export const haFattoIlRadar = (utente: unknown): boolean => {
  const profilo = utente as UtenteConRadar | null | undefined;

  if (!profilo) {
    return false;
  }

  return [
    profilo.productNameRadar,
    profilo.productDescriptionRadar,
    profilo.buyerRoleRadar
  ].some((risposta) => !!risposta?.trim());
};
